import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'
import { useState, useEffect } from 'react'
function CustomPhoneInput() {
    // `value` will be the parsed phone number in E.164 format.
    // Example: "+12133734253".
    const [value, setValue] = useState()
    return (
        <PhoneInput
            defaultCountry="IN"
            placeholder="Mobile No."
            value={value}
            onChange={setValue}
        />
    )
}
export default CustomPhoneInput;